
import React, { useState, useEffect } from 'react';
import Projects from './filters/Projects';
import ProcessAreas from './filters/ProcessAreas'
import ObjectTypes from './filters/ObjectTypes'
import Specifications from './filters/Specifications';
import CustomerTag from './filters/CustomerTag';
import ObjectName from './filters/ObjectName';
import RowInfo from './report/RowInfo';
import ObjectUid from './filters/ObjectUid';
import ParentObjectKey from './filters/ParentObjectKey';
import InternalTag from './filters/InternalTag';
import ObjectDescription from './filters/ObjectDescription';
import { Col, Row } from 'reactstrap';
import '../../styles/home/Home.css'
import MaxHits from './filters/MaxHits';
import GetReportButton from './report/GetReportButton';
import TabsAdd from '../layout/forms/TabsAdd';
import '../../styles/layout/forms/Tabs.css'

import ReactDOM from 'react-dom'

const Home = () => {
    const [state, setState] = useState({
        projects: [],
        processAreas: [],
        objectTypes: [],
        specifications: [],
        customerTag:'',
        objectName: '',
        objectUid: '',
        internalTag: '',
        objectDescription: '',
        parentObjectKey: '',
        maxHits: 1000        
    });
    const ClearData = () => {
        setData([]);
        setSelectedGlobalObjectKey(null);
        HideDivi();
    }

    const [data, setData] = useState([]);
    const [selectedGlobalObjectKey, setSelectedGlobalObjectKey] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [visible, setVisible] = useState();
    const SetSelectedGlobalObjectKey = (globalObjectKey) => {
        setSelectedGlobalObjectKey(globalObjectKey)
        setSelectedRow(data.find(obj => obj.specifications?.GlobalObjectKEY == globalObjectKey.toString()))
        ShowDivi();


    }
    function HideDivi() {

        const divi = document.getElementById('divId');
        divi.style.visibility = "hidden";
        
    }
    function ShowDivi() {

        const divi = document.getElementById('divId');
        divi.style.visibility = "visible";
                
    }
    useEffect(() => {
        document.title = "ObjectSearch"
    }, [])
    return (
        <>
            <div className="home-wrapper">
                <Row>
                <Col lg="4" md="6">
                    <Projects selected={state} setSelected={setState} />
                </Col>
                <Col lg="2" md="6">
                    <ProcessAreas selected={state} setSelected={setState} />
                </Col>
                <Col lg="2" md="4">
                    <ObjectTypes selected={state} setSelected={setState} />
                </Col>
                <Col lg="2" md="4">
                    <Specifications selected={state} setSelected={setState} />
                </Col>  
                <Col lg="2" md="4">
                    <MaxHits state={state} setState={setState} setSelected={setState} />
                </Col>    
                </Row>
                <Row>
                    <Col>
                        &nbsp;
                    </Col>
                </Row>
                <Row>
                    <Col lg="2" md="6">
                        <CustomerTag state={state} setState={setState}/>
                    </Col>
                    <Col lg="2" md="6">
                        <ObjectName state={state} setState={setState}/>
                    </Col>
                    <Col lg="2" md="4">
                        <ObjectUid state={state} setState={setState} />
                    </Col>
                    <Col lg="2" md="4">
                        <InternalTag state={state} setState={setState} />
                    </Col>
                    <Col lg="2" md="4">
                        <ParentObjectKey state={state} setState={setState} />
                    </Col>
                    <Col lg="2" md="4">
                        <ObjectDescription state={state} setState={setState} />
                    </Col>                
                </Row>
                <Row>
                    <Col md="4">                       
                            <GetReportButton state={state} setData={setData} ClearData={ClearData}/>
                    </Col>
                </Row>
            </div>
            <Row>              
                <Col sm>
                    <RowInfo rowData={selectedRow} />
                </Col>                  
            </Row>
            <div>          
                <TabsAdd
                    selectedRow={selectedRow}
                        selectedGlobalObjectKey={selectedGlobalObjectKey}
                        data={data}
                        state={state}
                        setSelectedGlobalObjectKey={SetSelectedGlobalObjectKey}                    
                    />               
            </div>
        </>
    );
};
export default Home;
